import Api from "../../Api"
import Request from "services/constants/Request.api"

class PlasticsOfficer extends Api {
  constructor(user) {
    super()
    this.user = user
  }

  getOfficerReviewDetails = data => {
    const request = new Request({
      data: {
        url:
          "application/officer-review?staff_id=" +
          data.staff_id +
          "&application_id=" +
          data.application_id,
        token: "Bearer " + this.user.token,
      },
    })

    return this.getRequest(request)
  }

  getAssignedTo(staff_id, page, nonReviewed = false) {
    let url =
      "staff/applications/reviewed-applications/" + staff_id + "?page=" + page
    if (nonReviewed) {
      url = "staff/applications/under-review/" + staff_id + "?page=" + page
    }
    const request = new Request({
      data: {
        url: url,
        token: "Bearer " + this.user.token,
      },
    })

    return this.getRequest(request)
  }

  reviewApplication = data => {
    const request = new Request({
      data: {
        url: "staff/application/review/" + data.application_id,
        decision_code: data.decision_code,
        reason: data.reason,
        comment_to_applicant: data.comment_to_applicant,
        token: "Bearer " + this.user.token,
      },
    })

    return this.postRequest(request)
  }

  getProcessingApplications(staff_id, page) {
    const request = new Request({
      data: {
        url: "applications/processing/staff/" + staff_id + "?page=" + page,
        token: "Bearer " + this.user.token,
      },
    })

    return this.getRequest(request)
  }

  getRejectedApplications(staff_id, page) {
    const request = new Request({
      data: {
        url: "applications/rejected/staff/" + staff_id + "?page=" + page,
        token: "Bearer " + this.user.token,
      },
    })

    return this.getRequest(request)
  }

  getReturnedApplications(staff_id, page) {
    const request = new Request({
      data: {
        url: "applications/sent-back/staff/" + staff_id + "?page=" + page,
        token: "Bearer " + this.user.token,
      },
    })

    return this.getRequest(request)
  }

  getApprovedApplications(staff_id, page) {
    const request = new Request({
      data: {
        url: "applications/approved/staff/" + staff_id + "?page=" + page,
        token: "Bearer " + this.user.token,
      },
    })

    return this.getRequest(request)
  }

  getConsumptionAreaItems = id => {
    const request = new Request({
      data: {
        url: "plastics/consumption-areas/" + id,
        token: "Bearer " + this.user.token,
      },
    })

    return this.getRequest(request)
  }

  updateConsumptionAreaItem = data => {
    const request = new Request({
      data: {
        url: "plastics/consumption-area-item/" + data.consumption_area_item_id,
        consumption_area_id: data.consumption_area_id,
        name: data.name,
        is_endorsed: data.is_endorsed,
        token: "Bearer " + this.user.token,
      },
    })

    return this.postRequest(request)
  }

  getManualApplications(staff_id, page) {
    // manually-processed/applications/9
    const request = new Request({
      data: {
        url: "manually-processed/applications/" + staff_id + "?page=" + page,
        token: "Bearer " + this.user.token,
      },
    })

    return this.getRequest(request)
  }
}

export default PlasticsOfficer
